import LegalLayout from '../components/legal/LegalLayout';

export default function PrivacyPage() {
  return <LegalLayout title="Privacy policy" dataId="79e77468-4c7d-424a-8ba4-a60b55a23c17" />;
}
